/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentContactsResponseData,
  GetDocumentContactsResponseDataFromJSON,
  GetDocumentContactsResponseDataFromJSONTyped,
  GetDocumentContactsResponseDataToJSON
} from './GetDocumentContactsResponseData'

/**
 *
 * @export
 * @interface GetDocumentContactsResponse
 */
export interface GetDocumentContactsResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentContactsResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentContactsResponseData}
   * @memberof GetDocumentContactsResponse
   */
  data?: GetDocumentContactsResponseData
}

export function GetDocumentContactsResponseFromJSON(json: any): GetDocumentContactsResponse {
  return GetDocumentContactsResponseFromJSONTyped(json, false)
}

export function GetDocumentContactsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocumentContactsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentContactsResponseDataFromJSON(json['data'])
  }
}

export function GetDocumentContactsResponseToJSON(value?: GetDocumentContactsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentContactsResponseDataToJSON(value.data)
  }
}
